import React from "react";
import Routers from "./Components/Routers/Routers";
import { MoonLoader } from "react-spinners";
function App() {
  return (
    <React.Fragment>
      <div id="tmoverlay" className="d-none">
        <div className="w-100 h-100 d-flex align-items-center justify-content-center">
          <MoonLoader
            css={`
              display: block;
              margin: 0 auto;
              margin-top: 20vh;
            `}
            size={50}
            color={"#1b67b3"}
          />
        </div>
      </div>
      <Routers />
    </React.Fragment>
  );
}

export default App;


